import { render, staticRenderFns } from "./FormRepeaterBasic.vue?vue&type=template&id=35d96d85&scoped=true"
import script from "./FormRepeaterBasic.vue?vue&type=script&lang=js"
export * from "./FormRepeaterBasic.vue?vue&type=script&lang=js"
import style0 from "./FormRepeaterBasic.vue?vue&type=style&index=0&id=35d96d85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d96d85",
  null
  
)

export default component.exports